import { render } from "./InvoicePreviewModal.vue?vue&type=template&id=67038f5a&scoped=true"
import script from "./InvoicePreviewModal.vue?vue&type=script&lang=js"
export * from "./InvoicePreviewModal.vue?vue&type=script&lang=js"

import "./InvoicePreviewModal.vue?vue&type=style&index=0&id=67038f5a&scoped=true&lang=css"

import exportComponent from "/Users/patrykslak/Documents/lauron-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67038f5a"]])

export default __exports__